import { translate } from 'hooks/useTranslate';
import { isShareClassVisible } from 'modules/trading/utils/isShareClassVisible';
import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

const getSharesCountLabel = (sharesSegment: string): string => {
  const count = sharesSegment.split(/\s+/)[0];

  if (!count) return sharesSegment;

  return `${count} ${translate('shares')}`;
};

export const formatHoldingClassOptionLabel = (label: string): string => {
  const parts = label.split('|').map((part) => part.trim());

  if (parts.length < 2) return label;

  const sharesLabel = getSharesCountLabel(parts[parts.length - 1]);

  if (isShareClassVisible()) {
    return `${parts[0]} | ${sharesLabel}`;
  }

  return sharesLabel;
};

export const mapHoldingClassOptionForDisplay = (
  option: CustomAsyncSelectOption | null | undefined
): CustomAsyncSelectOption | null => {
  if (!option) return null;

  return {
    ...option,
    label: formatHoldingClassOptionLabel(option.label),
  };
};

export const mapHoldingClassOptionsForDisplay = (
  options: CustomAsyncSelectOption[]
): CustomAsyncSelectOption[] =>
  options.map((option) => mapHoldingClassOptionForDisplay(option) as CustomAsyncSelectOption);

export const getHoldingClassDisplayName = (
  option: CustomAsyncSelectOption | null | undefined
): string => {
  if (!option || !isShareClassVisible()) return '';

  return option.label.split('|')[0]?.trim() || option.name || '';
};
